const styles = theme => ({
    offscreen: {
        position: 'absolute',
        left: -99999999
    },
    content: {
        minWidth: 500,
        '@media (max-width: 380px)': {
            minWidth: '100%'
        }
    },
    error: {
        color: theme.palette.error.main
    }

});

export default styles;